var _createClass = function () { function defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } } return function (Constructor, protoProps, staticProps) { if (protoProps) defineProperties(Constructor.prototype, protoProps); if (staticProps) defineProperties(Constructor, staticProps); return Constructor; }; }();

var _positions;

function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }

function _possibleConstructorReturn(self, call) { if (!self) { throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); } return call && (typeof call === "object" || typeof call === "function") ? call : self; }

function _inherits(subClass, superClass) { if (typeof superClass !== "function" && superClass !== null) { throw new TypeError("Super expression must either be null or a function, not " + typeof superClass); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, enumerable: false, writable: true, configurable: true } }); if (superClass) Object.setPrototypeOf ? Object.setPrototypeOf(subClass, superClass) : subClass.__proto__ = superClass; }

function _defineProperty(obj, key, value) { if (key in obj) { Object.defineProperty(obj, key, { value: value, enumerable: true, configurable: true, writable: true }); } else { obj[key] = value; } return obj; }

import * as React from 'react';
import TetherComponent from 'react-tether';
import uniqueId from 'lodash/uniqueId';

import './Flyout.scss';

var BOTTOM_CENTER = 'bottom-center';
var BOTTOM_LEFT = 'bottom-left';
var BOTTOM_RIGHT = 'bottom-right';
var MIDDLE_LEFT = 'middle-left';
var MIDDLE_RIGHT = 'middle-right';
var TOP_CENTER = 'top-center';
var TOP_LEFT = 'top-left';
var TOP_RIGHT = 'top-right';

var positions = (_positions = {}, _defineProperty(_positions, BOTTOM_CENTER, {
    attachment: 'top center',
    targetAttachment: 'bottom center'
}), _defineProperty(_positions, BOTTOM_LEFT, {
    attachment: 'top right',
    targetAttachment: 'bottom right'
}), _defineProperty(_positions, BOTTOM_RIGHT, {
    attachment: 'top left',
    targetAttachment: 'bottom left'
}), _defineProperty(_positions, MIDDLE_LEFT, {
    attachment: 'middle right',
    targetAttachment: 'middle left'
}), _defineProperty(_positions, MIDDLE_RIGHT, {
    attachment: 'middle left',
    targetAttachment: 'middle right'
}), _defineProperty(_positions, TOP_CENTER, {
    attachment: 'bottom center',
    targetAttachment: 'top center'
}), _defineProperty(_positions, TOP_LEFT, {
    attachment: 'bottom right',
    targetAttachment: 'top right'
}), _defineProperty(_positions, TOP_RIGHT, {
    attachment: 'bottom left',
    targetAttachment: 'top left'
}), _positions);

/**
 * Checks if there is a clickable ancestor or self
 * @param {Node} rootNode The base node we should stop at
 * @param {Node} targetNode The target node of the event
 * @returns {boolean}
 */
var hasClickableAncestor = function hasClickableAncestor(rootNode, targetNode) {
    // Check if the element or any of the ancestors are click-able (stopping at the component boundary)
    var currentNode = targetNode;
    while (currentNode && currentNode instanceof Node && currentNode.parentNode && currentNode !== rootNode) {
        var nodeName = currentNode.nodeName.toUpperCase();
        if (nodeName === 'A' || nodeName === 'BUTTON') {
            return true;
        }
        currentNode = currentNode.parentNode;
    }
    return false;
};

/**
 * Checks if the target element is inside an element with the given CSS class.
 * @param {HTMLElement} targetEl The target element
 * @param {string} className A CSS class on the element to check for
 */
var hasClassAncestor = function hasClassAncestor(targetEl, className) {
    var el = targetEl;
    while (el && el instanceof HTMLElement) {
        if (el.classList.contains(className)) {
            return true;
        }
        el = el.parentNode;
    }
    return false;
};

var Flyout = function (_React$Component) {
    _inherits(Flyout, _React$Component);

    function Flyout(props) {
        _classCallCheck(this, Flyout);

        var _this = _possibleConstructorReturn(this, (Flyout.__proto__ || Object.getPrototypeOf(Flyout)).call(this, props));

        _this.handleOverlayClick = function (event) {
            var overlayNode = document.getElementById(_this.overlayID);
            var _this$props = _this.props,
                closeOnClick = _this$props.closeOnClick,
                closeOnClickPredicate = _this$props.closeOnClickPredicate;

            if (!closeOnClick || !hasClickableAncestor(overlayNode, event.target)) {
                return;
            }
            if (closeOnClickPredicate && !closeOnClickPredicate(event)) {
                return;
            }

            _this.handleOverlayClose(event);
        };

        _this.handleButtonClick = function (event) {
            var isVisible = _this.state.isVisible;

            if (isVisible) {
                _this.closeOverlay(event);
            } else {
                _this.openOverlay();
            }

            // If button was clicked, the detail field should hold number of clicks.
            // If number is zero, the event was synthesized.
            // https://developer.mozilla.org/en-US/docs/Web/API/UIEvent/detail
            var isButtonClicked = event.detail > 0;

            _this.setState({ isButtonClicked: isButtonClicked });

            event.preventDefault();
        };

        _this.handleButtonHover = function (event) {
            var _this$props2 = _this.props,
                openOnHover = _this$props2.openOnHover,
                openOnHoverDelayTimeout = _this$props2.openOnHoverDelayTimeout;

            if (openOnHover) {
                clearTimeout(_this.hoverDelay);

                _this.hoverDelay = setTimeout(function () {
                    _this.openOverlay();
                }, openOnHoverDelayTimeout);
            }
        };

        _this.handleButtonHoverLeave = function (event) {
            var _this$props3 = _this.props,
                openOnHover = _this$props3.openOnHover,
                openOnHoverDelayTimeout = _this$props3.openOnHoverDelayTimeout;

            if (openOnHover) {
                clearTimeout(_this.hoverDelay);

                _this.hoverDelay = setTimeout(function () {
                    _this.closeOverlay();
                }, openOnHoverDelayTimeout);
            }
        };

        _this.openOverlay = function () {
            _this.setState({
                isVisible: true
            });

            var onOpen = _this.props.onOpen;

            if (onOpen) {
                onOpen();
            }
        };

        _this.closeOverlay = function (event) {
            _this.setState({
                isVisible: false
            });

            var onClose = _this.props.onClose;

            if (onClose) {
                onClose();
            }
        };

        _this.focusButton = function () {
            var buttonEl = document.getElementById(_this.overlayButtonID);
            if (buttonEl) {
                buttonEl.focus();
            }
        };

        _this.handleOverlayClose = function (event) {
            _this.focusButton();
            _this.closeOverlay(event);
        };

        _this.handleDocumentClickOrWindowBlur = function (event) {
            var _this$props4 = _this.props,
                portaledClasses = _this$props4.portaledClasses,
                closeOnClickOutside = _this$props4.closeOnClickOutside,
                closeOnWindowBlur = _this$props4.closeOnWindowBlur;
            var isVisible = _this.state.isVisible;


            if (!isVisible || !(closeOnClickOutside || closeOnWindowBlur)) {
                return;
            }

            var overlayNode = document.getElementById(_this.overlayID);
            var buttonNode = document.getElementById(_this.overlayButtonID);

            var isInsideToggleButton = buttonNode && event.target instanceof Node && buttonNode.contains(event.target) || buttonNode === event.target;
            var isInsideOverlay = overlayNode && event.target instanceof Node && overlayNode.contains(event.target) || overlayNode === event.target;
            var isInside = isInsideToggleButton || isInsideOverlay;

            if (isInside || portaledClasses.some(function (className) {
                return hasClassAncestor(event.target, className);
            })) {
                return;
            }

            // Only close overlay when the click is outside of the flyout or window loses focus
            _this.closeOverlay();
        };

        _this.state = {
            isVisible: props.isVisibleByDefault,
            isButtonClicked: false
        };
        return _this;
    }

    _createClass(Flyout, [{
        key: 'componentWillMount',
        value: function componentWillMount() {
            this.overlayID = uniqueId('overlay');
            this.overlayButtonID = uniqueId('flyoutbutton');
        }
    }, {
        key: 'componentDidUpdate',
        value: function componentDidUpdate(prevProps, prevState) {
            if (!prevState.isVisible && this.state.isVisible) {
                var _props = this.props,
                    _closeOnClickOutside = _props.closeOnClickOutside,
                    _closeOnWindowBlur = _props.closeOnWindowBlur;
                // When overlay is being opened

                if (_closeOnClickOutside) {
                    document.addEventListener('click', this.handleDocumentClickOrWindowBlur, true);
                    document.addEventListener('contextmenu', this.handleDocumentClickOrWindowBlur, true);
                }
                if (_closeOnWindowBlur) {
                    window.addEventListener('blur', this.handleDocumentClickOrWindowBlur, true);
                }
            } else if (prevState.isVisible && !this.state.isVisible) {
                // When overlay is being closed
                document.removeEventListener('contextmenu', this.handleDocumentClickOrWindowBlur, true);
                document.removeEventListener('click', this.handleDocumentClickOrWindowBlur, true);
                window.removeEventListener('blur', this.handleDocumentClickOrWindowBlur, true);
            }
        }
    }, {
        key: 'componentWillUnmount',
        value: function componentWillUnmount() {
            if (this.state.isVisible) {
                // Clean-up global click handlers
                document.removeEventListener('contextmenu', this.handleDocumentClickOrWindowBlur, true);
                document.removeEventListener('click', this.handleDocumentClickOrWindowBlur, true);
                window.removeEventListener('blur', this.handleDocumentClickOrWindowBlur, true);
            }

            if (this.props.openOnHover && this.hoverDelay) {
                clearTimeout(this.hoverDelay);
            }
        }
    }, {
        key: 'render',
        value: function render() {
            var _props2 = this.props,
                children = _props2.children,
                _props2$className = _props2.className,
                className = _props2$className === undefined ? '' : _props2$className,
                constrainToScrollParent = _props2.constrainToScrollParent,
                constrainToWindow = _props2.constrainToWindow,
                offset = _props2.offset,
                openOnHover = _props2.openOnHover,
                position = _props2.position,
                shouldDefaultFocus = _props2.shouldDefaultFocus;
            var _state = this.state,
                isButtonClicked = _state.isButtonClicked,
                isVisible = _state.isVisible;

            var elements = React.Children.toArray(children);
            var tetherPosition = positions[position];

            if (elements.length !== 2) {
                throw new Error('Flyout must have exactly two children: A button component and a <Overlay>');
            }

            var overlayButton = elements[0];
            var overlayContent = elements[1];

            var overlayButtonProps = {
                id: this.overlayButtonID,
                key: this.overlayButtonID,
                role: 'button',
                onClick: this.handleButtonClick,
                onMouseEnter: this.handleButtonHover,
                onMouseLeave: this.handleButtonHoverLeave,
                'aria-haspopup': 'true',
                'aria-expanded': isVisible ? 'true' : 'false'
            };

            if (isVisible) {
                overlayButtonProps['aria-controls'] = this.overlayID;
            }

            var overlayProps = {
                id: this.overlayID,
                key: this.overlayID,
                role: 'dialog',
                onClick: this.handleOverlayClick,
                onClose: this.handleOverlayClose,
                onMouseEnter: this.handleButtonHover,
                onMouseLeave: this.handleButtonHoverLeave,
                shouldDefaultFocus: shouldDefaultFocus || !isButtonClicked && !openOnHover,
                'aria-labelledby': this.overlayButtonID
            };

            var constraints = [];

            if (constrainToScrollParent) {
                constraints.push({
                    to: 'scrollParent',
                    attachment: 'together'
                });
            }

            if (constrainToWindow) {
                constraints.push({
                    to: 'window',
                    attachment: 'together'
                });
            }

            var tetherProps = {
                classPrefix: 'flyout-overlay',
                attachment: tetherPosition.attachment,
                targetAttachment: tetherPosition.targetAttachment,
                enabled: isVisible,
                classes: {
                    element: 'flyout-overlay ' + className
                },
                constraints: constraints
            };

            if (offset) {
                tetherProps.offset = offset;
            } else {
                switch (position) {
                    case BOTTOM_CENTER:
                    case BOTTOM_LEFT:
                    case BOTTOM_RIGHT:
                        tetherProps.offset = '-10px 0';
                        break;
                    case TOP_CENTER:
                    case TOP_LEFT:
                    case TOP_RIGHT:
                        tetherProps.offset = '10px 0';
                        break;
                    case MIDDLE_LEFT:
                        tetherProps.offset = '0 10px';
                        break;
                    case MIDDLE_RIGHT:
                        tetherProps.offset = '0 -10px';
                        break;
                    default:
                    // no default
                }
            }

            return React.createElement(
                TetherComponent,
                tetherProps,
                React.cloneElement(overlayButton, overlayButtonProps),
                isVisible ? React.cloneElement(overlayContent, overlayProps) : null
            );
        }
    }]);

    return Flyout;
}(React.Component);

Flyout.defaultProps = {
    className: '',
    closeOnClick: true,
    closeOnClickOutside: true,
    closeOnWindowBlur: false,
    constrainToScrollParent: true,
    constrainToWindow: false,
    isVisibleByDefault: false,
    openOnHover: false,
    openOnHoverDelayTimeout: 300,
    portaledClasses: [],
    position: BOTTOM_RIGHT
};
Flyout.propTypes = {
    children: PropTypes.node.isRequired,

    /**
     * Set className to the overlay wrapper
     */
    className: PropTypes.string,

    /**
     * If set to true, closes the overlay on clicking buttons/links inside
     * of it
     */
    closeOnClick: PropTypes.bool,

    /**
     * If set to true, closes the overlay on clicking outside of it
     */
    closeOnClickOutside: PropTypes.bool,

    /**
     * Function that will interrogate the click event to determine whether or not to close the overlay if closeOnClick is enabled
     */
    closeOnClickPredicate: PropTypes.func,

    /**
     * If set to true, closes the overlay when window loses focus
     */
    closeOnWindowBlur: PropTypes.bool,

    /**
     * Sets tether constrain to scrollParent
     */
    constrainToScrollParent: PropTypes.bool,

    /**
     * Sets tether constrain to window
     */
    constrainToWindow: PropTypes.bool,

    /**
     * Whether overlay should be visible by default
     */
    isVisibleByDefault: PropTypes.bool.isRequired,

    /**
     * Will fire this callback when the flyout should open
     */
    onOpen: PropTypes.func,

    /**
     * Will fire this callback when the flyout should close
     */
    onClose: PropTypes.func,

    /**
     * Adjusts placement of the overlay (SEE http://tether.io/#options)
     */
    offset: PropTypes.string,

    /**
     * Whether overlay should open on hover
     */
    openOnHover: PropTypes.bool,

    /**
     * Time in milliseconds that the button should wait before opening and closing the flyout
     */
    openOnHoverDelayTimeout: PropTypes.number,

    /** An array of CSS classes for portaled elements in the overlay, used to check whether a click is inside the overlay */
    portaledClasses: PropTypes.arrayOf(PropTypes.string).isRequired,

    /**
     * Position of the overlay
     */
    position: PropTypes.oneOf(['bottom-center', 'bottom-left', 'bottom-right', 'middle-left', 'middle-right', 'top-center', 'top-left', 'top-right']).isRequired,

    /**
     * Prop whether to focus first focusable element or not
     */
    shouldDefaultFocus: PropTypes.bool
};


export default Flyout;
import PropTypes from 'prop-types';